<template>
  <div>
    <div class="partner-block">
      <div class="skeleton partner-name"/>
      <div class="skeleton price"/>
      <div class="skeleton price"/>
    </div>
    <div class="flex items">
      <div class="skeleton image"/>
      <div class="item-details">
        <div class="name-sku">
        <div class="skeleton name"/>
        <div class="skeleton sku"/>
        <div class="skeleton qty"/>
        </div>
        <div class="price-and-delete">
          <div class="skeleton price"/>
          <div class="skeleton delete"/>
        </div>
      </div>
    </div>
    <div class="total">
      <div class="title-block">
        <div class="skeleton title"/>
      </div>
      <div class="price-block">
      <div class="skeleton price"/>
      <div class="skeleton price"/>
      <div class="skeleton mt-25 price"/>
      </div>
      <div class="buttons">
        <div class="skeleton back"/>
        <div class="skeleton button"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartSkeleton'
}
</script>

<style lang="scss" scoped>
 .skeleton {
   animation: skeleton-loading 1s linear infinite alternate;
   object-fit: cover;
   flex-shrink: 0;
 }
 .partner-block {
   width: 100%;
   height: 120px;
   text-align: -webkit-center;

   .partner-name {
     margin-top: 10px;
     width: 80px;
     height: 20px;
     text-align: center;
   }
   .price {
     width: 80%;
     height: 30px;
     margin-top: 10px;
   }
 }
 .items {
   width: 100%;
   height: 211px;
   background: #fff;
   padding-bottom: 40px;

   .image {
     width: 21%;
     height: 160px;
     margin-left: 40px;
     margin-top: 10px;
     @media (max-width: 500px) {
       width: 34%;
     }
     @media (max-width: 350px) {
        margin-left: 20px;
        width: 45%;
     }
   }
   .item-details {
     width: 70%;
     display: flex;
     margin-top: 10px;
     height: 75%;
     margin-left: 10px;
     .space {
       height: 55%;
     }
     @media (max-width: 650px) {
       width: 60%;
     }
     @media (max-width: 500px) {
       width: 50%;
     }
     @media (max-width: 350px) {
        width: 40%;
     }
   }
   .name-sku {
     width: 70%;
     position: relative;
     .name {
       width: 70%;
       height: 20px;
       @media (max-width: 400px) {
         width: 80%;
       }
     }
     .sku {
       width: 30%;
       height: 20px;
       margin-top: 10px;
       @media (max-width: 400px) {
         width: 50%;
       }
     }
     .qty {
       position: absolute;
       bottom: 0;
       width: 30%;
       height: 20px;
       @media (max-width: 400px) {
         width: 50%;
       }
     }
   }
   .price-and-delete {
     width: 30%;
     position: relative;
     .price {
       width: 100%;
       height: 20px;
     }
     .delete {
       height: 20px;
       position: absolute;
       bottom: 0;
       width: 100%;
     }
   }
 }
 .total {
   width: 100%;
   height: 240px;
   margin-top: 10px;
   .title-block {
     width: 100%;
     text-align: -webkit-center;
     .title {
       width: 140px;
       height: 20px;
     }
   }
   .price-block {
     width: 100%;
     text-align: -webkit-center;
     .price {
       width: 80%;
       height: 20px;
       margin-top: 10px;
     }
     .mt-25 {
       margin-top: 25px;
     }
   }
   .buttons {
     display: flex;
     margin-top: 30px;
     padding-left: 25px;
     padding-right: 25px;
     place-content: space-between;
     @media (max-width: 650px) {
       display: block;
       text-align: -webkit-center;
     }
     .back {
       width: 250px;
       height: 30px;
       @media (max-width: 650px) {
         width: 100%;
       }
     }

     .button {
       @media (max-width: 650px) {
         width: 40%;
         margin-top: 10px;
       }
       width: 250px;
       height: 30px;
     }
   }
 }

@keyframes skeleton-loading {
   0% {
     background-color: hsl(200, 20%, 70%);
   }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
}
</style>
